import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import book1 from '../media/book1.jpg';
import bookAbove991 from '../media/mapleinfobook.jpg';
import nutritionBG from '../media/maplestorageandnutritionalinfopagebackground.jpg';


export default class Nutrition extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>Nutritional Facts - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
      		<h1>Pure Maple Nutrition Facts & Information</h1>

          <BookImgsRow>
            <BookImgCol1 xs="12" lg="6">
              <SingleBookBgDiv>
                <h3>Maple Health Tips</h3>
                <HealthItemDiv>
                  <h4><u>REPLACE:</u></h4>
                  <p>{' '} Refined sugar with an alternative such as pure maple sugar or pure maple syrup.</p>
                </HealthItemDiv>
                <HealthItemDiv>
                  <h4><u>BAKE IT:</u></h4>
                  <p>{' '} Replace up to 1/2 the granulated sugar in recipes.</p>
                </HealthItemDiv>
                <HealthItemDiv>
                  <h4><u>DRINK IT</u></h4>
                  <p>{' '} Sweeten iced tea with pure maple, and infuse with fruit.</p>
                </HealthItemDiv>
                <HealthItemDiv>
                  <h4><u>VEG OUT:</u></h4>
                  <p>{' '} Use pure maple instead of brown sugar or corn syrup in glazed carrots, sweet potatoes, or other sweetened vegetable dishes.</p>
                </HealthItemDiv>
                <HealthItemDiv>
                  <h4><u>SWEET ENDINGS:</u></h4>
                  <p>{' '} Drizzle a little pure maple syrup on a bowl of ice cream or fresh fruit.</p>
                </HealthItemDiv>
              </SingleBookBgDiv>
            </BookImgCol1>

            <BookImgCol2 xs="12" lg="6">
              <SingleBookBgDivTwo>
                <h3>Maple Nutrition Research</h3>
                <h4>Courtesy of Cornell Sugar Maple Research & Extension Program:</h4>
                <p>Maple syrup contains 68% carbohydrates, while most other syrups contain 100%. While it has virtually 
                   the same calorie content as white cane sugar (50 calories per Tbsp.)
                   Additionally, maple syrup contains: Calcium: 20mg per Tbsp, Potassium: 35mg per Tbsp, 
                   Iron and Phosphorus: Small amounts, B Vitamins: Trace amounts, and a very low sodium content (2mg per Tbsp.) 
                </p>
                {/*<img src={require("../media/facesBucketLeaves.png")}></img>*/}
              </SingleBookBgDivTwo>
            </BookImgCol2>

          </BookImgsRow>

        </InternalContainer>
      </FluidContainer>
		);
	}
}

const HealthItemDiv = styled.div`
  h4, p {  }
`;

const SingleBookBgDiv = styled.div`
  padding: 20px 0 20px 50px;
  background-image: url(${book1}); 
  ${media.md` background-repeat: no-repeat; padding: 20px 170px 5px 50px; `}
  ${media.lg ` background-image: none; padding: 20px 0 0 50px; p { margin: 0 0 16px 0; } `}  
  ${media.xl ` padding: 20px 25px 20px 50px; `}
`;
const SingleBookBgDivTwo = styled.div`
  padding: 20px 0 20px 50px;
  background-image: url(${book1}); 
  ${media.md` background-repeat: no-repeat; padding: 20px 170px 5px 50px; `}
  ${media.lg ` background-image: none; padding: 20px 0 0 70px; p { margin: 0 0 16px 0; } `}  
  ${media.xl ` padding: 20px 100px 20px 0px; `}
`;

const BookImgCol1 = styled(Col)`
  margin: 0 0 20px 0;
  ${media.lg ` margin: 0 `}  
`;
const BookImgCol2 = styled(Col)`
  margin: 0 0 20px 0;
  ${media.lg ` margin: 0 `}  
  ${media.xl` padding: 0 10px 0 10px!important; `}
`;

const BookImgsRow = styled(Row)`
  margin: 40px 0 0 0;
  h3 { padding: 0px 0 24px 0; margin: 0; }
  ${media.lg ` background-image: url(${bookAbove991});`}  
`;



const FluidContainer = styled(Container)` 
  padding: 30px 0 20px 0!important; 
  background-image: url(${nutritionBG}); 
`;
const InternalContainer = styled(Container)` h1 {color: black!important;} `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/Nutrition.js